<template>
  <div class="clean-container">
    <!-- 顶部图片 -->
    <div class="clean-top-image-container">
      <img src="../../static/series/AdsorptionForce/clean1.png"  class="top-image"/>
    </div>

    <!-- 中间内容 -->
    <div class="clean-middle-section">
      <!-- 左侧数据对比 -->
      <div class="data-comparison">
        <div class="progress-page">
          <!-- 第一组进度条 -->
          <div class="clean-progress-bar-component">
            <p>{{ $t('series.extendedCleaning') }}</p>
            <div class="title" :style="{ color: progressGroups[0].titleColor }">
              {{ progressGroups[0].title }}
            </div>
            <div class="progress-container">
              <div class="progress-bg">
                <div
                    class="progress-fill"
                    :style="{
              width: progressGroups[0].progress + '%',
              backgroundColor: progressGroups[0].barColor
            }"
                ></div>
              </div>
              <div
                  class="progress-text"
                  :style="{ color: progressGroups[0].textColor }"
              >
                {{ progressGroups[0].customText }}
              </div>
            </div>
            <div class="description">{{ progressGroups[0].description }}</div>
          </div>
          <!-- 第二组进度条 -->
          <div class="clean-progress-bar-component">
            <div class="title" :style="{ color: progressGroups[1].titleColor }">
              {{ progressGroups[1].title }}
            </div>
            <div class="progress-container">
              <div class="progress-bg">
                <div
                    class="progress-fill"
                    :style="{
              width: progressGroups[1].progress + '%',
              backgroundColor: progressGroups[1].barColor
            }"
                ></div>
              </div>
              <div
                  class="progress-text"
                  :style="{ color: progressGroups[1].textColor }"
              >
                {{ progressGroups[1].customText }}
              </div>
            </div>
            <div class="description">{{ progressGroups[1].description }}</div>
          </div>
          <!-- 第三组进度条 -->
          <div class="clean-progress-bar-component">
            <p>{{ $t('series.impactFilterClogging') }}</p>
            <div class="title" :style="{ color: progressGroups[2].titleColor }">
              {{ progressGroups[2].title }}
            </div>
            <div class="progress-container">
              <div class="progress-bg">
                <div
                    class="progress-fill"
                    :style="{
              width: progressGroups[2].progress + '%',
              backgroundColor: progressGroups[2].barColor
            }"
                ></div>
              </div>
              <div
                  class="progress-text"
                  :style="{ color: progressGroups[2].textColor }"
              >
                {{ progressGroups[2].customText }}
              </div>
            </div>
            <div class="description">{{ progressGroups[2].description }}</div>
          </div>
          <div class="clean-progress-bar-component">
            <div class="title" :style="{ color: progressGroups[3].titleColor }">
              {{ progressGroups[3].title }}
            </div>
            <div class="progress-container">
              <div class="progress-bg">
                <div
                    class="progress-fill"
                    :style="{
              width: progressGroups[3].progress + '%',
              backgroundColor: progressGroups[3].barColor
            }"
                ></div>
              </div>
              <div
                  class="progress-text"
                  :style="{ color: progressGroups[3].textColor }"
              >
                {{ progressGroups[3].customText }}
              </div>
            </div>
            <div class="description">{{ progressGroups[3].description }}</div>
          </div>
        </div>
      </div>

      <!-- 右侧产品信息 -->
      <div class="product-section">
        <!-- 产品名称（不放在卡片中） -->
        <div class="product-name">
          <span class="brand">Galaxy</span>
          <span class="model">Vortex45</span>
        </div>

        <!-- 产品描述和图片放在卡片中 -->
        <div class="product-card">
          <!--          <div class="product-desc">旋风+滤筒 2合1</div>-->
          <div class="product-image-container">
            <img src="../../static/series/AdsorptionForce/clean2.png" alt="产品示意图" class="product-diagram"/>
          </div>
        </div>
      </div>
    </div>

    <!-- 左下角内容 -->
    <div class="clean-bottom-left-section">
      <!-- 可添加其他内容 -->
    </div>
  </div>
</template>

<script>
export default {
  name: "CleanCycle",
  data() {
    return {
      progressGroups: [
        {
          title: '',
          titleColor: '#d86ecc',
          progress: 100,
          barColor: '#d86ecc',
          textColor: '#d86ecc',
          customText: '300%',
          description: ''
        },
        {
          title: this.$i18n.t('series.clogging_other'),
          titleColor: '#000000',
          progress: 30,
          barColor: '#808080',
          textColor: '#000000',
          customText: '',
          description: ''
        },
        {
          title: '',
          titleColor: '#4e95dd',
          progress: 30,
          barColor: '#4e95dd',
          textColor: '#4e95dd',
          customText: '30%',
          description: ''
        },
        {
          title: this.$i18n.t('series.clogging_other'),
          titleColor: '#808080',
          progress: 90,
          barColor: '#808080',
          textColor: '#808080',
          customText: '',
          description: ''
        }
      ],
      isMobile: false,
      timeline: null
    }
  },
  mounted() {
    // 检测设备类型
    this.checkDeviceType();

    this.$nextTick(() => {
      this.initAnimation();
    });

    // 监听窗口大小变化
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    // 清理事件监听和动画
    window.removeEventListener('resize', this.handleResize);
    if (this.timeline) {
      this.timeline.kill();
    }
    this.$ScrollTrigger.getAll().forEach(trigger => {
      if (trigger.trigger === '.clean-container') {
        trigger.kill();
      }
    });
  },
  methods: {
    checkDeviceType() {
      this.isMobile = window.innerWidth < 768;
    },
    handleResize() {
      const newIsMobile = window.innerWidth < 768;
      if (newIsMobile !== this.isMobile) {
        this.isMobile = newIsMobile;
        if (this.timeline) {
          this.timeline.kill();
        }
        this.initAnimation();
        this.$ScrollTrigger.refresh();
      }
    },
    initAnimation() {
      const masterTimeline = this.$gsap.timeline({
        scrollTrigger: {
          trigger: '.clean-container',
          start: 'top 80%',
          end: 'bottom 20%',
          markers: false,
          // scrub: 1,
          toggleActions: 'play none none none',
          once: true
        }
      })

      masterTimeline.from('.clean-top-image-container', {
        ease: 'power2.in',
        y: 50,
        opacity: 0,
        delay: 0.2,
        duration: 0.8
      })

      masterTimeline.from('.clean-middle-section', {
        ease: 'power2.in',
        y: 50,
        opacity: 0,
        delay: 0.2,
        duration: 0.8
      })
    }
  }
};
</script>

<style scoped>
.clean-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
  background-color: #f5f5f7;
  margin-top: 200px;
}

/* 顶部图片样式 */
.clean-top-image-container {
  width: 85%;
  margin-bottom: 20px;
}

.top-image {
  width: 85%;
  height: auto;
}

/* 中间内容样式 */
.clean-middle-section {
  display: flex;
  width: 100%;
  margin-bottom: 20px;
  gap: 10px;
  align-items: center;
  justify-content: flex-start;
}

/* 左侧数据对比样式 */
.data-comparison {
  width: 60%;
}

.progress-page {
  width: 85%;
  display: flex;
  flex-direction: column;
  position: relative;
  left: 10%;
  align-items: center;
}

.clean-progress-bar-component {
  width: 60%;
}

.title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 10px;
  text-align: left;
}

.progress-container {
  display: flex;
  align-items: center;
  margin-bottom: 5px;
  gap: 10px;
}

.progress-bg {
  height: 10px;
  border-radius: 5px;
  flex: 1;
  overflow: hidden;
}

.progress-fill {
  height: 100%;
  border-radius: 5px;
  transition: width 0.5s ease;
}

.progress-text {
  font-size: 1.2em;
  min-width: 60px;
  text-align: right;
}

.description {
  font-size: 1em;
  color: #6b7280;
  text-align: left;
}

.progress-page p {
  margin-top: 20px;
  color: black;
  text-align: left;
  font-size: 1.5em;
}

/* 右侧产品区域样式 */
.product-section {
  width: 20%;
  display: flex;
  flex-direction: column;
  gap: 15px; /* 名称与卡片之间的间距 */
}

/* 产品名称样式（不放在卡片中） */
.product-name {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.brand {
  font-size: 1.2em;
  color: #808080;
  margin-bottom: 5px;
}

.model {
  font-size: 2em;
  color: #808080;
}

/* 产品卡片样式（仅包含描述和图片） */
.product-card {
  background-color: white;
  border-radius: 8px;
  padding: 25px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  box-sizing: border-box;
}

.product-desc {
  font-size: 1em;
  color: #666;
  margin-bottom: 20px;
  line-height: 1.5;
}

.product-image-container {
  width: 100%;
  display: flex;
  justify-content: center;
}

.product-diagram {
  width: 100%;
  height: auto;
  object-fit: contain;
}

/* 左下角内容样式 */
.clean-bottom-left-section {
  width: 100%;
}

/* 手机端适配样式 */
@media (max-width: 767px) {
  .clean-container {
    padding: 15px;
  }

  .clean-top-image-container {
    width: 100%;
    margin-bottom: 15px;
  }

  .clean-middle-section {
    flex-direction: column; /* 改为垂直布局 */
    width: 100%;
    gap: 30px;
    margin-bottom: 30px;
  }

  .data-comparison {
    width: 90%; /* 数据区域占满宽度 */
  }

  .progress-page {
    width: 100%;
    left: 0; /* 移除左侧偏移 */
    padding: 0 5%;
  }

  .clean-progress-bar-component {
    width: 100%; /* 进度条组件占满宽度 */
    margin-bottom: 20px;
  }

  .progress-page p {
    font-size: 1.3em;
    margin-top: 15px;
    margin-bottom: 5px;
  }

  .title {
    font-size: 16px;
  }

  .progress-text {
    font-size: 1em;
    min-width: 40px;
  }

  .product-section {
    width: 100%; /* 产品区域占满宽度 */
    padding: 0 5%;
  }

  .product-name {
    align-items: center; /* 产品名称居中 */
    margin-bottom: 10px;
  }

  .brand {
    font-size: 1.1em;
  }

  .model {
    font-size: 1.8em;
  }

  .product-card {
    width: 100%;
    padding: 20px;
    align-items: center; /* 卡片内容居中 */
  }

  .product-desc {
    font-size: 0.95em;
    text-align: center;
    margin-bottom: 15px;
  }

  .product-diagram {
    max-width: 250px; /* 限制产品图最大宽度 */
  }
}
</style>

